import { Editor, Element, Range } from '../core';
import { isSquareBracketType } from '../constants';
import { DEPLOY_ENV } from 'config';

export const areMultipleSiblingBracketsSelected = (editor: Editor): boolean => {
  const { selection } = editor;
  if (selection == null || Range.isCollapsed(selection)) {
    return false;
  }

  try {
    const bracketPaths = Array.from(
      Editor.nodes(editor, {
        at: selection,
        match: (n) => Element.isElement(n) && isSquareBracketType(n.type),
      })
    ).map(([, path]: [any, any]) => path);

    if (bracketPaths.length < 2) {
      return false;
    }

    // We only care about sibling brackets that are jointly covered by the current selection.
    // Using parent paths avoids false positives from unrelated brackets elsewhere in the document.
    const siblingParentPathCounts = new Map<string, number>();
    for (const path of bracketPaths) {
      const parentPathKey = JSON.stringify(path.slice(0, -1));
      const nextCount = (siblingParentPathCounts.get(parentPathKey) ?? 0) + 1;
      siblingParentPathCounts.set(parentPathKey, nextCount);
      if (nextCount > 1) {
        return true;
      }
    }
  } catch (e: any) {
    // The editor's selection might be out of sync with the latest transform which
    // will cause this call to fail and throw. This function is called during the
    // render of a React component, meaning if we do not catch it we will crash
    // the editor. Being out of sync does not mean there is a bug, once the selection
    // syncs up the component that calls this will re-render and should work.
    if (DEPLOY_ENV !== 'production') {
      console.warn(e);
    }
    return false;
  }

  return false;
};
